import LightBox from "./light-box";
import LightBoxBody from "./light-box-body";
import LoginForm from "./login-form";
import pure from "./higher-order/pure";
import React from "react";
import SignupLink from "./signup-link";

export default pure(function LoginLightBox({ errorMessage, loading, onClose, onLogin }) {
  return (
    <LightBox onClose={onClose} title="Log in to your account.">
      <LightBoxBody>
        <LoginForm errorMessage={errorMessage} loading={loading} onLogin={onLogin} />

        <div className="batch-g batch-g--padding batch-g--valign-center">
          <div className="batch-c-1-1 batch-c-md-5-24" />

          <div className="batch-c-1-1 batch-c-md-19-24">
            <span className="text-small color--is-medium-gray">
              Don&apos;t have an account?
              {" "}

              <SignupLink className="display--is-block-mobile">
                Create FREE account now.
              </SignupLink>
            </span>
          </div>
        </div>
      </LightBoxBody>
    </LightBox>
  );
});
